import { motion } from 'framer-motion'
import { Building2 } from 'lucide-react'

const facilities = [
  {
    id: 'mt-weld',
    title: 'Mt Weld',
    subtitle: 'Western Australia',
    tag: 'Mine',
    image: '/assets/mt-weld-mine.png',
  },
  {
    id: 'kalgoorlie',
    title: 'Kalgoorlie',
    subtitle: 'Western Australia',
    tag: 'Processing Facility',
    image: '/assets/hero-background.png',
  },
  {
    id: 'malaysia',
    title: 'Kuantan',
    subtitle: 'Pahang, Malaysia',
    tag: 'Processing Facility',
    image: '/assets/malaysia-kuantan.png',
  },
  {
    id: 'seadrift',
    title: 'Seadrift',
    subtitle: 'Texas, USA',
    tag: 'Processing Facility',
    image: '/assets/seadrift.png',
  },
]

export default function FacilitySelect() {
  return (
    <section id="facilities" className="relative pt-28 md:pt-32 pb-16 md:pb-24 bg-slate-950 overflow-hidden">
      <div className="container mb-12 md:mb-16 text-center">
        <h2 className="text-sm font-semibold text-accent uppercase tracking-wider mb-3">Global Operations</h2>
        <h3 className="text-3xl md:text-4xl font-bold font-heading text-white tracking-tight leading-tight">
          Mine to market
        </h3>
      </div>

      <div className="container px-0 md:px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
          {facilities.map((facility, i) => (
            <motion.div
              key={facility.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="group relative aspect-[2/3] md:aspect-[3/5] rounded-lg overflow-hidden ring-2 ring-transparent ring-offset-2 ring-offset-slate-950 transition-all duration-300 hover:ring-accent/50"
            >
              {/* Background image */}
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                style={{ backgroundImage: `url(${facility.image})` }}
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/95 via-slate-900/40 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-90" />
              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-4 md:p-6">
                <span className="text-[10px] md:text-xs font-semibold text-accent uppercase tracking-widest mb-1">
                  {facility.tag}
                </span>
                <h4 className="text-lg md:text-xl font-bold font-heading text-white tracking-tight">
                  {facility.title}
                </h4>
                <p className="text-sm text-white/80">{facility.subtitle}</p>
              </div>
              {/* Hover accent line */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-accent opacity-0 transition-opacity duration-300 group-hover:opacity-70" />
            </motion.div>
          ))}
        </div>
      </div>

      {/* Headquarters note */}
      <div className="container mt-8 md:mt-10">
        <div className="flex items-center justify-center gap-2 text-white/60">
          <Building2 className="h-4 w-4 flex-shrink-0" />
          <span className="text-sm">Headquarters located in Perth, Western Australia</span>
        </div>
      </div>
    </section>
  )
}
